import { render, staticRenderFns } from "./addInternalBack.vue?vue&type=template&id=1b66e7a7&scoped=true"
import script from "./addInternalBack.vue?vue&type=script&lang=js"
export * from "./addInternalBack.vue?vue&type=script&lang=js"
import style0 from "./addInternalBack.vue?vue&type=style&index=0&id=1b66e7a7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b66e7a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b66e7a7')) {
      api.createRecord('1b66e7a7', component.options)
    } else {
      api.reload('1b66e7a7', component.options)
    }
    module.hot.accept("./addInternalBack.vue?vue&type=template&id=1b66e7a7&scoped=true", function () {
      api.rerender('1b66e7a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/InternalDelivery/addInternal/addInternalBack.vue"
export default component.exports